import React from 'react';
import { useLocale } from '../../context/LocaleContext';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopLeaveSectionProps {
  registrationState: 'interest' | 'confirmed';
  onLeave: () => void;
  leaving?: boolean;
}

const WorkshopLeaveSection: React.FC<WorkshopLeaveSectionProps> = ({
  registrationState,
  onLeave,
  leaving = false,
}) => {
  const { t } = useLocale();
  const isConfirmed = registrationState === 'confirmed';

  return (
    <section id="leave-workshop" className={styles.leaveWorkshopSection}>
      <h3 className={styles.leaveWorkshopTitle}>{t('workshop.2026.leave.title')}</h3>
      <p className={styles.leaveWorkshopText}>
        {isConfirmed
          ? t('workshop.2026.leave.body_confirmed')
          : t('workshop.2026.leave.body_interest')}
      </p>
      <button type="button" className={styles.leaveWorkshopBtn} onClick={onLeave} disabled={leaving}>
        {leaving
          ? t('workshop.2026.leave.removing')
          : isConfirmed
            ? t('workshop.2026.leave.btn_confirmed')
            : t('workshop.2026.leave.btn_interest')}
      </button>
    </section>
  );
};

export default WorkshopLeaveSection;
